<!-- OOTB Implementation -->
<div class="row">
  <div class="component col-12 py-2">
    @if ((featuredProductList$ | async)?.length > 0) {
      <h2 class="featured-products-heading">
      {{"homePageHeader.topFeaturedProducts"|cxTranslate}} </h2>
    }
    @if (featuredProductList$ | async; as productList) {
      <div class="mb-3">
        <div class="col-12 pl-0 pr-0">
          <div class="row m-0">
            @for (product of productList; track product; let i = $index) {
              <div class="col-md-6 col-lg-4 col-xl-3 mb-3 px-2 align-items-stretch"
                > <!-- slice:0:3 -->
                <div [attr.data-ste-teaser-title]="product?.name || product?.code"
                  data-ste-teaser-type="product" [attr.data-ste-teaser-index]="i + 1">
                  <app-card-template
                    [productId]="product?.baseProduct"
                    [productName]="product?.name"
                    [code]="product?.code"
                    [productPrice]="product?.discountPriceData?.value"
                    [currency]="product?.discountPriceData?.currencyIso"
                    [userLoggedIn]="(userLoggedIn | async) === false"
                    [minimumQty]="getUpdatedMinQty(product?.minQuantity, product?.interval)"
                    [qtyStep]="product?.interval > 0 ? product?.interval : 1"
                    [productNavigateUrl]="getProductUrl(product?.url)"
                    [obsoleteFlag]="product?.obsoleteFlag"
                    [quotationFlag]="product?.quotationFlag"
                    [productImageUrl]="getImageUrl(product?.images)"
                    [productPriceLoading]="product?.priceLoading"
                    [productPriceError]="product?.priceError"
                    [errorCode]="product?.error"
                    (getPrice)="onGetPrice($event)">
                  </app-card-template>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>

<!-- Old implementation
<div>
  <div class="row">
    <div class="component col-12 py-2">
      <div>
        <h2 *ngIf="showTopProducts" class="featured-products-heading">  {{"homePageHeader.topFeaturedProducts"|cxTranslate}} </h2>
        <div *ngIf="featuredProductList | async as productList" class="mb-3">
          <div class="col-12 pl-0 pr-0">
            <div class="row m-0">
              <div class="col-md-6 col-lg-4 col-xl-3 mb-3 px-2 align-items-stretch"
                *ngFor="let product of productList?.products; let i = index;">
                <app-card-template
                  [index]="i"
                  (addToCartClk)="addToCart($event)"
                  [productId]="product?.baseProduct"
                  [productName]="product?.name"
                  [productPrice]="product?.discountPriceData.value"
                  [currency]="product?.discountPriceData.currencyIso"
                  [userLoggedIn]="!(userLoggedIn | async)"
                  [minimumQty]="getUpdatedMinQty(product?.minQuantity, product?.interval)"
                  [maximumQty]="product?.maxQuantity > 0 ? product?.maxQuantity : 1000"
                  [productQuantity]="product?.minQuantity > 0 ? product.minQuantity : 1"
                  [qtyStep]="product?.interval > 0 ? product?.interval : 1"
                  [productNavigateUrl]="getProductUrl(product?.url)"
                  [obsoleteFlag]="product?.obsoleteFlag"
                  [quotationFlag]="product?.quotationFlag"
                  [productImageUrl]="getImageUrl(product?.images)">
                </app-card-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->